import { render, staticRenderFns } from "./PortalPopover.vue?vue&type=template&id=97428a6c&"
import script from "./PortalPopover.vue?vue&type=script&lang=js&"
export * from "./PortalPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97428a6c')) {
      api.createRecord('97428a6c', component.options)
    } else {
      api.reload('97428a6c', component.options)
    }
    module.hot.accept("./PortalPopover.vue?vue&type=template&id=97428a6c&", function () {
      api.rerender('97428a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/helpcenter/components/PortalPopover.vue"
export default component.exports